import React, { useState, useEffect, useRef, useCallback } from "react";
import "./App.css";
import axios from "axios";
import CodeMirror from "@uiw/react-codemirror";
import { createTheme } from "@uiw/codemirror-themes";
import { sql, SQLDialect } from "@codemirror/lang-sql";
import { EditorView, keymap } from "@codemirror/view";
import Split from "react-split";
import DataTable from "./DataTable"; // Import your DataTable component
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
  useParams,
} from "react-router-dom";
import Home from "./Home";
// const deepEqual = require('deep-equal');
// var deepEqual = require('fast-deep-equal');
import { FcPrevious, FcNext } from "react-icons/fc";
import { BsListCheck } from "react-icons/bs";
import { BiLogoPostgresql } from "react-icons/bi";
import { SiPostgresql } from "react-icons/si";
import { ToastContainer, toast } from "react-toastify";
import { IoArrowBack } from "react-icons/io5";
import { IoArrowForward } from "react-icons/io5";
import { IoKey } from "react-icons/io5";
import { qs } from "qs";
import { RiHistoryLine } from "react-icons/ri";
import { FaKeyboard } from "react-icons/fa";

import "react-toastify/dist/ReactToastify.css";
import logo from "./logo_img.png";
import { autocompletion } from "@codemirror/autocomplete";
import { EditorState } from "@codemirror/state";
import { searchKeymap } from "@codemirror/search";
import { search } from "@codemirror/search";

function Main() {
  const [sqlQuery, setSqlQuery] = useState("");
  const [results, setResults] = useState([]);
  const [correct, setCorrect] = useState("");
  const [loading, setLoading] = useState(true);
  const [question, setQuestion] = useState();
  const [queryerror, setQueryerror] = useState("");
  const { id } = useParams();
  const [isButtonDisabled, setButtonDisabled] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 640);
  const [isEditorExpanded, setIsEditorExpanded] = useState(false);
  const [popoutPosition, setPopoutPosition] = useState({ x: 50, y: 50 });
  const dragRef = useRef(null);
  const [expandedSize, setExpandedSize] = useState({ width: 800, height: 600 });
  const resizeRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState({ line: 1, column: 1 });
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  // Dark mode state with localStorage persistence
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Initialize from localStorage, default to false if not found
    const savedDarkMode = localStorage.getItem("sqlguru-dark-mode");
    return savedDarkMode ? JSON.parse(savedDarkMode) : false;
  });

  // Effect to save dark mode preference to localStorage
  useEffect(() => {
    localStorage.setItem("sqlguru-dark-mode", JSON.stringify(isDarkMode));
  }, [isDarkMode]);

  // Question Dropdown state
  const [questionsDropdown, setQuestionsDropdown] = useState(false);
  const [availableQuestions, setAvailableQuestions] = useState([]);
  const [dropdownSearch, setDropdownSearch] = useState("");
  const dropdownRef = useRef(null);
  const dropdownButtonRef = useRef(null);

  // Query History state
  const [queryHistory, setQueryHistory] = useState([]);
  const [showQueryHistory, setShowQueryHistory] = useState(false);
  const queryHistoryRef = useRef(null);
  const queryHistoryButtonRef = useRef(null);

  // Keyboard shortcuts state
  const [showKeyboardShortcuts, setShowKeyboardShortcuts] = useState(false);
  const [isHoveringShortcuts, setIsHoveringShortcuts] = useState(false);
  const keyboardShortcutsRef = useRef(null);
  const keyboardShortcuts = [
    {
      key: "Ctrl+Enter",
      macKey: "⌘+Enter",
      description: "Execute Query",
    },
    {
      key: "Ctrl+Shift+Enter",
      macKey: "⌘+Shift+Enter",
      description: "Submit Query",
    },
    {
      key: "Ctrl+F",
      macKey: "⌘+F",
      description: "Search in Editor",
    },
    {
      key: "Alt+F",
      macKey: "⌥+F",
      description: "Format SQL",
    },
    {
      key: "Alt+H",
      macKey: "⌥+H",
      description: "Toggle Query History",
    },
    {
      key: "Esc",
      macKey: "Esc",
      description: "Close Modals/Panels",
    },
  ];

  // Timer state
  const [time, setTime] = useState(0);
  const [timerRunning, setTimerRunning] = useState(false);
  const timerRef = useRef(null);

  // Timer functions
  const startTimer = () => {
    if (!timerRunning) {
      setTimerRunning(true);
      timerRef.current = setInterval(() => {
        setTime((prevTime) => prevTime + 1);
      }, 1000);
    }
  };

  const pauseTimer = () => {
    if (timerRunning) {
      clearInterval(timerRef.current);
      setTimerRunning(false);
    }
  };

  const resetTimer = () => {
    clearInterval(timerRef.current);
    setTimerRunning(false);
    setTime(0);
  };

  // Format time for display (HH:MM:SS)
  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;

    return [
      hours.toString().padStart(2, "0"),
      minutes.toString().padStart(2, "0"),
      seconds.toString().padStart(2, "0"),
    ].join(":");
  };

  // Clean up timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  // Add cursor position tracking extension
  const cursorPositionExtension = EditorView.updateListener.of((update) => {
    if (update.docChanged || update.selectionSet) {
      const pos = update.state.selection.main.head;
      const line = update.state.doc.lineAt(pos);
      setCursorPosition({
        line: line.number,
        column: pos - line.from + 1,
      });
    }
  });

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 640);
    };

    // Attach the event listener
    window.addEventListener("resize", handleResize);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount

  // const backendUrl = 'https://sqlguru-service.onrender.com';
  const backendUrl = "http://195.35.23.51:3001";

  const handlePrevPage = () => {
    // Assuming page is a string, you might want to convert it to a number
    const prevPage = parseInt(id, 10) - 1;
    // Redirect to the next page
    if (prevPage < 1) {
      return;
    }
    window.location.href = `/question/${prevPage}`;
  };

  const handleNextPage = () => {
    // Assuming page is a string, you might want to convert it to a number
    const nextPage = parseInt(id, 10) + 1;
    // Redirect to the next page
    if (nextPage >= 10000) {
      return;
    }
    window.location.href = `/question/${nextPage}`;
  };

  // Fetch available questions for dropdown
  const fetchAvailableQuestions = async () => {
    try {
      // Fetch actual questions from the API
      const questionPromises = Array.from({ length: 20 }, (_, i) =>
        axios
          .get(`https://sqlguroo.com/api/get-specific-data/${i + 1}`)
          .then((response) => ({
            id: i + 1,
            title: response.data[0]?.question || `Question ${i + 1}`,
            difficulty: i < 7 ? "Easy" : i < 14 ? "Medium" : "Hard",
          }))
          .catch((error) => ({
            id: i + 1,
            title: `Question ${i + 1}`,
            difficulty: i < 7 ? "Easy" : i < 14 ? "Medium" : "Hard",
          }))
      );

      const questions = await Promise.all(questionPromises);
      setAvailableQuestions(questions);
    } catch (error) {
      console.error("Error fetching questions:", error);
      // Fallback to numbered questions
      const questions = Array.from({ length: 20 }, (_, i) => ({
        id: i + 1,
        title: `Question ${i + 1}`,
        difficulty: i < 7 ? "Easy" : i < 14 ? "Medium" : "Hard",
      }));
      setAvailableQuestions(questions);
    }
  };

  // Toggle questions dropdown
  const toggleQuestionsDropdown = () => {
    if (!questionsDropdown && availableQuestions.length === 0) {
      fetchAvailableQuestions();
    }
    setQuestionsDropdown(!questionsDropdown);
    setDropdownSearch("");
  };

  // Navigate to selected question
  const navigateToQuestion = (questionId) => {
    setQuestionsDropdown(false);
    setDropdownSearch("");
    window.location.href = `/question/${questionId}`;
  };

  // Filter questions based on search
  const filteredQuestions = availableQuestions.filter(
    (q) =>
      q.title.toLowerCase().includes(dropdownSearch.toLowerCase()) ||
      q.id.toString().includes(dropdownSearch)
  );

  // Get current question text for dropdown button
  const getCurrentQuestionText = () => {
    if (question && question[0] && question[0].question) {
      return question[0].question;
    }
    return `Question ${id}`;
  };

  // Helper function to truncate text
  const truncateText = (text, maxLength) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + "...";
  };

  const handleQueryChange = (e) => {
    setSqlQuery(e);
  };

  // Generate a default SQL query based on the question data
  const generateDefaultQuery = (questionData) => {
    if (!questionData || !questionData[0]) return "";

    // Extract table name from table_name1
    const tableNameMatch =
      questionData[0].table_name1 &&
      questionData[0].table_name1.match(/table name - ([^:]+):/);
    const tableName = tableNameMatch ? tableNameMatch[1].trim() : "";

    if (!tableName) return "";

    // Generate a basic SELECT query with the table name
    return `SELECT * FROM ${tableName} LIMIT 10;`;
  };

  const getItemData = async () => {
    try {
      const response = await axios.get(
        `https://sqlguroo.com/api/get-specific-data/${id}`
      );
      const specificData = response.data;
      setQuestion(specificData);

      // Set default query based on the question data
      setSqlQuery(generateDefaultQuery(specificData));

      console.log(specificData);
    } catch (error) {
      console.error("Error fetching specific data:", error);
    }
  };

  const executeQuery = async () => {
    setLoading(true);
    setCorrect("");
    setButtonDisabled(true);

    setTimeout(async () => {
      if (/DROP|ALTER/i.test(sqlQuery)) {
        setQueryerror("Only Select statements are allowed");
        console.log("Only Select statements are allowed");
        setResults([]);
        setTimeout(async () => {
          setButtonDisabled(false);
        }, 1400);
        return;
      }

      try {
        // let res = await axios.post('https://sqlguru-service.onrender.com/executeQuery/', { sqlQuery })

        let res = await axios.post(
          "https://sqlguroo.com/api/executeQuery/",
          { sqlQuery },
          {
            timeout: 5000, // Set the timeout to 5 seconds (5000 milliseconds)
          }
        );

        let { data } = res.data;
        setLoading(false);
        setResults(res.data);
        // console.log(res.data)
        setQueryerror("");

        // Save query to history if it's not empty and not already in history
        if (
          sqlQuery.trim() &&
          !queryHistory.some((item) => item.query === sqlQuery)
        ) {
          // Add timestamp and limit history to last 20 queries
          const newHistoryItem = {
            query: sqlQuery,
            timestamp: new Date(),
            successful: true,
          };
          setQueryHistory((prev) => [newHistoryItem, ...prev].slice(0, 20));
        }
      } catch (e) {
        if (axios.isCancel(e)) {
          console.log("Request canceled:", e.message);
          setQueryerror(e.message);
          setResults([]);
        } else {
          console.log(e.response ? e.response.data.error : e);
          setQueryerror(e.response ? e.response.data.error : "Unknown Error");
          setResults([]);

          // Save failed query to history
          if (
            sqlQuery.trim() &&
            !queryHistory.some((item) => item.query === sqlQuery)
          ) {
            const newHistoryItem = {
              query: sqlQuery,
              timestamp: new Date(),
              successful: false,
              error: e.response ? e.response.data.error : "Unknown Error",
            };
            setQueryHistory((prev) => [newHistoryItem, ...prev].slice(0, 20));
          }
        }
      }

      setButtonDisabled(false);
    }, 1400);
  };

  function areTablesEqual(tableA, tableB) {
    // Check if the tables have the same number of rows
    if (tableA.length !== tableB.length) {
      return false;
    }

    // Create arrays to store sorted row data for comparisonss
    const sortedTableA = [];
    const sortedTableB = [];

    // Sort the rows in both tables by their values
    for (const row of tableA) {
      const sortedRow = Object.values(row).sort();
      sortedTableA.push(sortedRow);
    }

    for (const row of tableB) {
      const sortedRow = Object.values(row).sort();
      sortedTableB.push(sortedRow);
    }

    // Sort the entire array to ensure consistent order
    sortedTableA.sort();
    sortedTableB.sort();

    // Compare the sorted arrays
    for (let i = 0; i < sortedTableA.length; i++) {
      for (let j = 0; j < sortedTableA[i].length; j++) {
        if (sortedTableA[i][j] !== sortedTableB[i][j]) {
          return false;
        }
      }
    }

    return true;
  }

  const submitQuery = async () => {
    if (results.length !== 0 && question !== null) {
      // Perform your processing on 'result' here
      // For example, you can log it or update other state variables

      setButtonDisabled(true);
      setCorrect("");

      setTimeout(async () => {
        try {
          const jsonString1 = JSON.stringify(question[0].output, null, 2);
          const jsonString2 = JSON.stringify(results, null, 2);

          // const jsonString1 = JSON.stringify(question[0].output, Object.keys(question[0].output).sort());
          // const jsonString2 = JSON.stringify(results, Object.keys(results).sort());

          console.log(jsonString1);
          console.log(jsonString2);

          // const areEqual = jsonString1 === jsonString2;

          const areEqual = areTablesEqual(question[0].output, results);

          if (areEqual) {
            setCorrect("Correct");
          } else {
            setCorrect("Incorrect");
          }
        } catch (error) {
          console.error("Error parsing JSON:", error);
          setCorrect("false");
        }
        setButtonDisabled(false);
      }, 1400);
    }
  };

  useEffect(() => {
    getItemData();
  }, []);

  const KEYWORDS = [
    "select",
    "from",
    "where",
    "and",
    "or",
    "not",
    "in",
    "between",
    "contains",
    "array",
    "limit",
    "offset",
    "union",
    "intersect",
    "except",
    "order by",
    "asc",
    "desc",
  ];

  const TENSORS = ["images", "labels"];

  const dialect = SQLDialect.define({
    keywords: KEYWORDS.join(" "),
    builtin: TENSORS.join(" "),
  });

  // Add this function to ensure window stays within viewport
  const ensureWindowInBounds = (x, y, width, height) => {
    const maxX = window.innerWidth - width;
    const maxY = window.innerHeight - height;
    return {
      x: Math.max(0, Math.min(x, maxX)),
      y: Math.max(0, Math.min(y, maxY)),
    };
  };

  // Update the handleResizeStart function
  const handleResizeStart = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startY = e.clientY;
    const startWidth = expandedSize.width;
    const startHeight = expandedSize.height;

    const handleResize = (e) => {
      const newWidth = Math.max(
        400,
        Math.min(window.innerWidth * 0.95, startWidth + (e.clientX - startX))
      );
      const newHeight = Math.max(
        300,
        Math.min(window.innerHeight * 0.95, startHeight + (e.clientY - startY))
      );

      // Adjust position if needed to keep window in bounds
      const adjustedPosition = ensureWindowInBounds(
        popoutPosition.x,
        popoutPosition.y,
        newWidth,
        newHeight
      );

      setExpandedSize({ width: newWidth, height: newHeight });
      setPopoutPosition(adjustedPosition);
    };

    const handleResizeEnd = () => {
      document.removeEventListener("mousemove", handleResize);
      document.removeEventListener("mouseup", handleResizeEnd);
    };

    document.addEventListener("mousemove", handleResize);
    document.addEventListener("mouseup", handleResizeEnd);
  };

  // Update the handleDragStart function
  const handleDragStart = (e) => {
    const startX = e.clientX - popoutPosition.x;
    const startY = e.clientY - popoutPosition.y;

    const handleDrag = (e) => {
      const newPosition = ensureWindowInBounds(
        e.clientX - startX,
        e.clientY - startY,
        expandedSize.width,
        expandedSize.height
      );
      setPopoutPosition(newPosition);
    };

    const handleDragEnd = () => {
      document.removeEventListener("mousemove", handleDrag);
      document.removeEventListener("mouseup", handleDragEnd);
    };

    document.addEventListener("mousemove", handleDrag);
    document.addEventListener("mouseup", handleDragEnd);
  };

  // Add search panel toggle function
  const toggleSearch = useCallback(() => {
    setIsSearchOpen((prev) => !prev);
  }, []);

  // Add keyboard shortcut for search
  const searchShortcut = keymap.of([
    {
      key: "Ctrl-f",
      run: toggleSearch,
      preventDefault: true,
    },
  ]);

  // Format SQL query
  const formatSqlQuery = () => {
    const formattedQuery = sqlQuery
      .replace(/\s+/g, " ")
      .replace(/\s*([,()])\s*/g, "$1 ")
      .replace(
        /\s+(AND|OR|ON|WHERE|FROM|SELECT|JOIN|LEFT|RIGHT|INNER|GROUP BY|ORDER BY|HAVING|LIMIT)\s+/gi,
        "\n$1 "
      )
      .replace(/SELECT\s+/i, "SELECT\n  ")
      .replace(/,\s*/g, ",\n  ")
      .trim();
    setSqlQuery(formattedQuery);
    console.log("SQL formatted");
  };

  // Load a query from history
  const loadQueryFromHistory = (historyItem) => {
    setSqlQuery(historyItem.query);
    setShowQueryHistory(false);
  };

  // Toggle query history
  const toggleQueryHistory = () => {
    console.log("Toggling query history");
    setShowQueryHistory((prev) => !prev);
    setShowKeyboardShortcuts(false);
  };

  // Add keyboard shortcut effect
  useEffect(() => {
    const handleKeyDown = (e) => {
      // For debugging
      console.log(
        "Key pressed:",
        e.key,
        "Alt:",
        e.altKey,
        "Ctrl:",
        e.ctrlKey,
        "Meta:",
        e.metaKey,
        "Code:",
        e.code
      );

      const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform);

      // Execute query: Ctrl+Enter (Windows) or Command+Enter (Mac)
      if (
        (isMac && e.metaKey && e.key === "Enter" && !e.shiftKey) ||
        (!isMac && e.ctrlKey && e.key === "Enter" && !e.shiftKey)
      ) {
        e.preventDefault();
        if (!isButtonDisabled) {
          executeQuery();
        }
      }

      // Submit query: Ctrl+Shift+Enter (Windows) or Command+Shift+Enter (Mac)
      if (
        (isMac && e.metaKey && e.shiftKey && e.key === "Enter") ||
        (!isMac && e.ctrlKey && e.shiftKey && e.key === "Enter")
      ) {
        e.preventDefault();
        if (!isButtonDisabled) {
          submitQuery();
        }
      }

      // Format SQL: Alt+F
      if (e.altKey && e.code === "KeyF") {
        e.preventDefault();
        formatSqlQuery();
      }

      // Toggle query history: Alt+H
      if (e.altKey && e.code === "KeyH") {
        e.preventDefault();
        toggleQueryHistory();
      }

      // Close modals/panels: Esc
      if (e.key === "Escape") {
        setShowQueryHistory(false);
        setShowKeyboardShortcuts(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isButtonDisabled, sqlQuery]);

  // Add click outside handler
  useEffect(() => {
    function handleClickOutside(event) {
      // Close query history if clicked outside
      if (
        showQueryHistory &&
        queryHistoryRef.current &&
        queryHistoryButtonRef.current &&
        !queryHistoryRef.current.contains(event.target) &&
        !queryHistoryButtonRef.current.contains(event.target)
      ) {
        setShowQueryHistory(false);
      }

      // Close questions dropdown if clicked outside
      if (
        questionsDropdown &&
        dropdownRef.current &&
        dropdownButtonRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !dropdownButtonRef.current.contains(event.target)
      ) {
        setQuestionsDropdown(false);
      }
    }

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showQueryHistory, questionsDropdown]);

  return (
    <div
      className={`relative flex h-screen overflow-hidden justify-center ${
        isDarkMode ? "bg-gray-900" : "bg-white"
      }`}
      data-theme={isDarkMode ? "dark" : "light"}
    >
      {/* // <div className="relative flex flex-col w-full h-screen overflow-hidden"> */}
      <div
        className={`relative flex flex-col 
                    w-full 
                    max-w-[98%]            /* Default max width */
                    
                    2xl:max-w-[1820px]     /* 2XL screens */
                    mx-auto 
                    h-screen 
                    overflow-hidden ${isDarkMode ? "bg-gray-900" : ""}`}
      >
        {/* <nav className="bg-white border-b border-gray-200 px-4 py-2.5 shadow-sm">
                        <div className="flex justify-between items-center w-full">
                            <div className="flex items-center gap-2">
                                <Link to="/" className="flex-shrink-0">
                                    <img
                                        src={logo}
                                        alt="SQL Guroo Logo"
                                        className="w-48 md:w-64 h-auto"
                                    />
                                </Link>

                                <div className="hidden sm:flex items-center gap-1">
                                    <button
                                        onClick={handlePrevPage}
                                        className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                                        aria-label="Previous page"
                                    >
                                        <FcPrevious className="text-xl" />
                                    </button>
                                    <button
                                        onClick={handleNextPage}
                                        className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
                                        aria-label="Next page"
                                    >
                                        <FcNext className="text-xl" />
                                    </button>
                                </div>
                            </div>

                            <div className="hidden sm:block ml-auto">
                                <h1 className="text-base xl:text-xl font-semibold text-gray-700 whitespace-nowrap">
                                    Practice, Learn, and Master SQL!
                                </h1>
                            </div>
                        </div>
                    </nav> */}

        <nav
          className={`${
            isDarkMode
              ? "bg-gray-800 border-gray-700"
              : "bg-white border-gray-200"
          } border-b px-4 py-2.5 shadow-sm relative z-50`}
        >
          <div className="flex justify-between items-center w-full">
            {/* Left side: Logo and Navigation */}
            <div className="flex items-center gap-2">
              <Link to="/" className="flex-shrink-0">
                <div className="flex items-center text-5xl font-extrabold">
                  <span
                    className={`${
                      isDarkMode ? "text-gray-100" : "text-gray-800"
                    }`}
                  >
                    SQL
                  </span>
                  <div
                    className={`relative ${
                      isDarkMode
                        ? "bg-blue-900 text-blue-300 border border-blue-700"
                        : "bg-blue-100 text-blue-800"
                    } text-xl font-semibold me-2 px-2.5 py-0.5 rounded ms-2 flex items-center shadow-sm`}
                  >
                    Guroo
                    <div className="absolute -top-3 -right-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-8 h-8"
                        viewBox="0 0 24 24"
                        style={{
                          transform: "rotate(25deg)",
                          color: isDarkMode ? "#60a5fa" : "#1a1a1a",
                        }}
                      >
                        {/* Main cap */}
                        <path
                          fill="currentColor"
                          d="M12 2L1 7l11 5 11-5-11-5zm0 6.5l-8-3.64V15l8 3.64 8-3.64V4.86l-8 3.64z"
                        />
                        {/* Tassel */}
                        <path
                          d="M21 7L21.5 8L27.5 24"
                          stroke="currentColor"
                          strokeWidth="1.2"
                          fill="none"
                          strokeLinecap="round"
                        />
                        {/* Tassel knot */}
                        <circle cx="21" cy="7" r="0.5" fill="currentColor" />
                      </svg>
                    </div>
                  </div>
                </div>
              </Link>

              {/* Navigation Buttons */}
              <div className="flex justify-center">
                <nav
                  aria-label="Pagination"
                  className="flex items-center gap-3 ml-4"
                >
                  <div className="flex items-center gap-3 ml-4">
                    {/* Question Progress Indicator */}
                    <div className="flex items-center gap-3">
                      <button
                        onClick={handlePrevPage}
                        disabled={parseInt(id, 10) <= 1}
                        className={`p-2 rounded-lg transition-all duration-300 border group
                          ${
                            parseInt(id, 10) <= 1
                              ? isDarkMode
                                ? "bg-gray-700 text-gray-500 border-gray-600 cursor-not-allowed"
                                : "bg-gray-50 text-gray-300 border-gray-200 cursor-not-allowed"
                              : isDarkMode
                              ? "bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-600 hover:to-gray-700 text-gray-200 border-gray-600 hover:border-gray-500 hover:shadow-md"
                              : "bg-gradient-to-r from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-200 text-gray-700 border-gray-200 hover:border-gray-300 hover:shadow-md"
                          }`}
                        aria-label="Previous question"
                      >
                        <FcPrevious className="text-xl transform group-hover:scale-110 transition-transform" />
                      </button>

                      {/* Questions Dropdown */}
                      <div className="relative">
                        <button
                          ref={dropdownButtonRef}
                          onClick={toggleQuestionsDropdown}
                          className={`px-3 py-2 rounded-lg transition-all duration-300 border group min-w-0 max-w-xs ${
                            questionsDropdown
                              ? isDarkMode
                                ? "bg-blue-900 text-blue-300 border-blue-700"
                                : "bg-blue-100 text-blue-700 border-blue-200"
                              : isDarkMode
                              ? "bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-600 hover:to-gray-700 text-gray-200 border-gray-600 hover:border-gray-500 hover:shadow-md"
                              : "bg-gradient-to-r from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-200 text-gray-700 border-gray-200 hover:border-gray-300 hover:shadow-md"
                          }`}
                          aria-label="Select question"
                          title={getCurrentQuestionText()}
                        >
                          <div className="flex items-center gap-2 min-w-0">
                            <svg
                              className="w-4 h-4 flex-shrink-0 transform group-hover:scale-110 transition-transform"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M4 6h16M4 12h16M4 18h16"
                              />
                            </svg>
                            <span className="text-sm font-medium truncate min-w-0">
                              {truncateText(getCurrentQuestionText(), 35)}
                            </span>
                            <svg
                              className={`w-4 h-4 flex-shrink-0 transition-transform ${
                                questionsDropdown ? "rotate-180" : ""
                              }`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </button>

                        {/* Dropdown Menu */}
                        {questionsDropdown && (
                          <div
                            ref={dropdownRef}
                            className={`absolute top-12 left-0 z-50 w-96 ${
                              isDarkMode
                                ? "bg-gray-800 border-gray-600"
                                : "bg-white border-gray-200"
                            } rounded-lg shadow-lg border max-h-96 overflow-hidden`}
                          >
                            {/* Header */}
                            <div
                              className={`${
                                isDarkMode
                                  ? "bg-blue-900 border-blue-700"
                                  : "bg-blue-50 border-blue-100"
                              } border-b px-4 py-2 flex justify-between items-center`}
                            >
                              <div className="flex items-center gap-2">
                                <svg
                                  className={`w-4 h-4 ${
                                    isDarkMode
                                      ? "text-blue-400"
                                      : "text-blue-500"
                                  }`}
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h16M4 18h16"
                                  />
                                </svg>
                                <h3
                                  className={`text-sm font-medium ${
                                    isDarkMode
                                      ? "text-gray-200"
                                      : "text-gray-700"
                                  }`}
                                >
                                  Select Question
                                </h3>
                              </div>
                              <button
                                onClick={() => setQuestionsDropdown(false)}
                                className={`${
                                  isDarkMode
                                    ? "text-gray-400 hover:text-gray-200"
                                    : "text-gray-400 hover:text-gray-600"
                                }`}
                              >
                                <svg
                                  className="w-4 h-4"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                  />
                                </svg>
                              </button>
                            </div>

                            {/* Search */}
                            <div className="p-3 border-b border-gray-200 dark:border-gray-700">
                              <input
                                type="text"
                                placeholder="Search questions..."
                                value={dropdownSearch}
                                onChange={(e) =>
                                  setDropdownSearch(e.target.value)
                                }
                                className={`w-full px-3 py-2 text-sm rounded-md border ${
                                  isDarkMode
                                    ? "bg-gray-700 border-gray-600 text-gray-200 placeholder-gray-400"
                                    : "bg-white border-gray-300 text-gray-900 placeholder-gray-500"
                                } focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
                              />
                            </div>

                            {/* Questions List */}
                            <div className="overflow-y-auto max-h-64">
                              {filteredQuestions.length === 0 ? (
                                <div
                                  className={`p-4 text-center ${
                                    isDarkMode
                                      ? "text-gray-400"
                                      : "text-gray-500"
                                  } text-sm`}
                                >
                                  No questions found
                                </div>
                              ) : (
                                <ul
                                  className={`divide-y ${
                                    isDarkMode
                                      ? "divide-gray-700"
                                      : "divide-gray-100"
                                  }`}
                                >
                                  {filteredQuestions.map((question) => (
                                    <li
                                      key={question.id}
                                      className={`p-2 ${
                                        isDarkMode
                                          ? "hover:bg-gray-700"
                                          : "hover:bg-gray-50"
                                      } cursor-pointer transition-colors ${
                                        parseInt(id) === question.id
                                          ? isDarkMode
                                            ? "bg-blue-900/50 border-l-2 border-blue-500"
                                            : "bg-blue-50 border-l-2 border-blue-500"
                                          : ""
                                      }`}
                                      onClick={() =>
                                        navigateToQuestion(question.id)
                                      }
                                    >
                                      <div className="flex items-center justify-between gap-2">
                                        <div className="flex items-center gap-2 min-w-0 flex-1">
                                          <span
                                            className={`text-xs px-2 py-0.5 rounded flex-shrink-0 font-medium ${
                                              isDarkMode
                                                ? "bg-gray-700 text-gray-300"
                                                : "bg-gray-100 text-gray-600"
                                            }`}
                                          >
                                            Q{question.id}
                                          </span>
                                          {parseInt(id) === question.id && (
                                            <span
                                              className={`text-xs px-2 py-0.5 rounded flex-shrink-0 font-medium ${
                                                isDarkMode
                                                  ? "bg-blue-900 text-blue-300"
                                                  : "bg-blue-100 text-blue-800"
                                              }`}
                                            >
                                              Current
                                            </span>
                                          )}
                                          <span
                                            className={`text-sm ${
                                              isDarkMode
                                                ? "text-gray-200"
                                                : "text-gray-900"
                                            } truncate`}
                                            title={question.title}
                                          >
                                            {truncateText(question.title, 80)}
                                          </span>
                                        </div>
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="flex flex-col items-center">
                        <div
                          className={`${
                            isDarkMode
                              ? "bg-gray-700 border-gray-600"
                              : "bg-white border-gray-200"
                          } px-3 py-1.5 rounded-lg border shadow-sm`}
                        >
                          <div className="flex items-center gap-2">
                            <span
                              className={`text-sm font-semibold ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Question
                            </span>
                            <div className="flex items-center gap-1">
                              <span
                                className={`text-sm font-bold ${
                                  isDarkMode ? "text-blue-400" : "text-blue-600"
                                }`}
                              >
                                {id}
                              </span>
                              <span
                                className={`text-sm ${
                                  isDarkMode ? "text-gray-500" : "text-gray-400"
                                }`}
                              >
                                /
                              </span>
                              <span
                                className={`text-sm ${
                                  isDarkMode ? "text-gray-400" : "text-gray-500"
                                }`}
                              >
                                20
                              </span>
                            </div>
                          </div>
                        </div>
                        {/* Progress bar */}
                        <div
                          className={`w-full h-1 ${
                            isDarkMode ? "bg-gray-600" : "bg-gray-100"
                          } rounded-full mt-1 overflow-hidden`}
                        >
                          <div
                            className="h-full bg-gradient-to-r from-blue-500 to-blue-600 transition-all duration-300"
                            style={{
                              width: `${(parseInt(id, 10) / 20) * 100}%`,
                            }}
                          ></div>
                        </div>
                      </div>

                      <button
                        onClick={handleNextPage}
                        disabled={parseInt(id, 10) >= 20}
                        className={`p-2 rounded-lg transition-all duration-300 border group
                          ${
                            parseInt(id, 10) >= 20
                              ? isDarkMode
                                ? "bg-gray-700 text-gray-500 border-gray-600 cursor-not-allowed"
                                : "bg-gray-50 text-gray-300 border-gray-200 cursor-not-allowed"
                              : isDarkMode
                              ? "bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-600 hover:to-gray-700 text-gray-200 border-gray-600 hover:border-gray-500 hover:shadow-md"
                              : "bg-gradient-to-r from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-200 text-gray-700 border-gray-200 hover:border-gray-300 hover:shadow-md"
                          }`}
                        aria-label="Next question"
                      >
                        <FcNext className="text-xl transform group-hover:scale-110 transition-transform" />
                      </button>
                    </div>
                  </div>
                </nav>
              </div>
            </div>

            {/* Right side: Tagline */}
            <div className="hidden sm:flex items-center justify-center gap-4">
              {/* Dark Mode Toggle */}
              <button
                onClick={() => setIsDarkMode(!isDarkMode)}
                className={`p-2 rounded-lg transition-all duration-300 border ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600 text-yellow-400 border-gray-600"
                    : "bg-gray-50 hover:bg-gray-100 text-gray-600 border-gray-200"
                } shadow-sm hover:shadow-md`}
                title={
                  isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"
                }
                aria-label={
                  isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"
                }
              >
                {isDarkMode ? (
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  <svg
                    className="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                  </svg>
                )}
              </button>

              <div className="relative px-4 py-2 rounded-lg">
                <h1
                  className={`text-xl font-bold tracking-tight ${
                    isDarkMode
                      ? "bg-gradient-to-r from-blue-400 via-blue-300 to-indigo-400"
                      : "bg-gradient-to-r from-blue-700 via-blue-600 to-indigo-700"
                  } bg-clip-text text-transparent drop-shadow-sm`}
                >
                  <span className="inline-flex items-center">
                    <span>Practice</span>
                    <span
                      className={`mx-1.5 ${
                        isDarkMode ? "text-gray-500" : "text-slate-400"
                      }`}
                    >
                      •
                    </span>
                    <span>Learn</span>
                    <span
                      className={`mx-1.5 ${
                        isDarkMode ? "text-gray-500" : "text-slate-400"
                      }`}
                    >
                      •
                    </span>
                    <span>Master SQL</span>
                  </span>
                </h1>
                <div className="absolute h-0.5 w-1/2 bg-gradient-to-r from-blue-500 to-indigo-500 bottom-0 left-1/4"></div>
              </div>
            </div>
          </div>
        </nav>

        <Split
          // class="wrap"
          sizes={[40, 60]}
          minSize={100}
          expandToMin={false}
          gutterSize={10}
          gutterAlign="center"
          snapOffset={30}
          dragInterval={1}
          direction="horizontal"
          cursor="col-resize"
          className="split flex flex-row overflow-hidden h-full"
        >
          <div
            className={`${
              isDarkMode
                ? "border-gray-700 bg-gray-800"
                : "border-gray-200 bg-white"
            } border rounded-lg shadow flex flex-col h-full`}
          >
            {/* Fixed Header - Completely separate from scrollable content */}
            <div
              className={`flex flex-row justify-between items-center px-4 py-3 ${
                isDarkMode
                  ? "border-gray-700 bg-gray-800"
                  : "border-gray-200 bg-white"
              } border-b`}
            >
              <Link to="/">
                <button
                  type="button"
                  className={`inline-flex items-center gap-1.5 px-3 py-2 ${
                    isDarkMode
                      ? "bg-gray-700 hover:bg-gray-600 text-gray-200 border-gray-600"
                      : "bg-gray-50 hover:bg-gray-100 text-gray-700"
                  } rounded-md transition-colors text-sm font-medium`}
                >
                  <BsListCheck className="text-lg" />
                  <span className="hidden sm:inline">All Questions</span>
                </button>
              </Link>

              <div className="flex space-x-3">
                <button
                  onClick={() =>
                    document.getElementById("my_modal_3").showModal()
                  }
                  className={`inline-flex items-center gap-1.5 px-3 py-2 ${
                    isDarkMode
                      ? "bg-blue-900 hover:bg-blue-800 text-blue-300 border-blue-700"
                      : "bg-blue-50 hover:bg-blue-100 text-blue-600 border-blue-200"
                  } rounded-md transition-colors text-sm font-medium border`}
                >
                  <SiPostgresql className="text-lg" />
                  <span>PostgreSQL Syntax</span>
                </button>

                <button
                  onClick={() =>
                    document.getElementById("my_modal_2").showModal()
                  }
                  className="inline-flex items-center gap-1.5 px-3 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-md transition-colors text-sm font-medium"
                >
                  <IoKey className="text-base" />
                  <span>Solution</span>
                </button>
              </div>
            </div>

            {/* Scrollable Content Area - Completely separate from header */}
            <div
              className={`overflow-y-auto p-4 flex-grow ${
                isDarkMode ? "bg-gray-800" : ""
              }`}
            >
              {/* Solution Modal */}
              <dialog
                id="my_modal_2"
                className="modal"
                onClick={(e) => {
                  // Close modal when clicking the backdrop (outside the modal content)
                  if (e.target.id === "my_modal_2") {
                    document.getElementById("my_modal_2").close();
                  }
                }}
              >
                <div
                  className="modal-box max-w-3xl bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden"
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Header with gradient background */}
                  <div className="bg-gradient-to-r from-emerald-600 to-teal-700 px-6 py-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                        />
                      </svg>
                      <h3 className="text-xl font-semibold text-white">
                        Solution
                      </h3>
                    </div>
                    <form method="dialog">
                      <button className="btn btn-sm btn-circle bg-white/20 hover:bg-white/30 border-0 text-white">
                        ✕
                      </button>
                    </form>
                  </div>

                  <div className="p-6">
                    <div className="mb-4 flex justify-end items-center">
                      <button
                        onClick={() => {
                          const solution = question ? question[0].solution : "";
                          navigator.clipboard
                            .writeText(solution)
                            .then(() => {
                              // Show a toast or some indicator that copy was successful
                              toast.success("Solution copied to clipboard", {
                                position: "bottom-right",
                                autoClose: 2000,
                              });
                            })
                            .catch((err) => {
                              console.error("Error copying text: ", err);
                            });
                        }}
                        className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-md transition-colors text-xs font-medium border border-slate-200"
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-2M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
                          />
                        </svg>
                        <span>Copy Solution</span>
                      </button>
                    </div>

                    <div className="bg-gray-800 rounded-lg p-1 shadow-inner">
                      <CodeMirror
                        className="min-h-[20rem] rounded-md overflow-auto"
                        extensions={[sql({ dialect }), EditorView.lineWrapping]}
                        height="20rem"
                        value={question ? question[0].solution : ""}
                        options={{ readOnly: true }}
                        theme="dark"
                        basicSetup={{
                          lineNumbers: true,
                          highlightActiveLineGutter: true,
                          highlightSpecialChars: true,
                          foldGutter: true,
                          dropCursor: true,
                          allowMultipleSelections: true,
                          indentOnInput: true,
                          bracketMatching: true,
                          highlightActiveLine: true,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </dialog>

              {/* PostgreSQL Syntax Modal */}
              <dialog
                id="my_modal_3"
                className="modal"
                onClick={(e) => {
                  // Close modal when clicking the backdrop (outside the modal content)
                  if (e.target.id === "my_modal_3") {
                    document.getElementById("my_modal_3").close();
                  }
                }}
              >
                <div
                  className="modal-box max-w-5xl bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="flex items-center justify-between bg-blue-600 px-6 py-4">
                    <div className="flex items-center gap-3">
                      <SiPostgresql className="text-white text-2xl" />
                      <h3 className="text-xl font-semibold text-white">
                        PostgreSQL Syntax Guide
                      </h3>
                    </div>
                    <form method="dialog">
                      <button className="btn btn-sm btn-circle bg-white/20 hover:bg-white/30 border-0 text-white">
                        ✕
                      </button>
                    </form>
                  </div>

                  <div className="p-6 overflow-y-auto max-h-[70vh]">
                    <p className="text-gray-600 mb-4">
                      Quick reference for commonly used PostgreSQL syntax. Hover
                      over examples for more details.
                    </p>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Basic SELECT Structure */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2">
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                            />
                          </svg>
                          <h4 className="font-medium">
                            Basic SELECT Structure
                          </h4>
                        </div>
                        <div className="p-4">
                          <pre className="font-mono text-sm bg-white p-3 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`SELECT column1, column2
                                                            FROM table_name
                                                            WHERE condition
                                                            GROUP BY column1
                                                            HAVING condition
                                                            ORDER BY column1 [ASC|DESC]
                                                            LIMIT n;`}
                          </pre>
                        </div>
                      </div>

                      {/* Date/Time Functions */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2">
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            />
                          </svg>
                          <h4 className="font-medium">Date/Time Functions</h4>
                        </div>
                        <div className="p-4">
                          <p className="mb-2 text-sm text-gray-600">
                            Date comparison:
                          </p>
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 mb-3 whitespace-pre-wrap">
                            {`date_column = DATE '2020-01-01'`}
                          </pre>
                          <p className="mb-2 text-sm text-gray-600">
                            Extract parts:
                          </p>
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`EXTRACT(MONTH FROM date_column)
EXTRACT(YEAR FROM date_column)
EXTRACT(DOW FROM date_column)`}
                          </pre>
                        </div>
                      </div>

                      {/* Aggregation Functions */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2">
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
                            />
                          </svg>
                          <h4 className="font-medium">Aggregation Functions</h4>
                        </div>
                        <div className="p-4">
                          <pre className="font-mono text-sm bg-white p-3 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`COUNT(*) -- count rows
SUM(column) -- sum values
AVG(column) -- average
MIN(column) -- minimum value
MAX(column) -- maximum value`}
                          </pre>
                        </div>
                      </div>

                      {/* JOIN Types */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2">
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                            />
                          </svg>
                          <h4 className="font-medium">JOIN Types</h4>
                        </div>
                        <div className="p-4">
                          <p className="mb-2 text-sm text-gray-600">
                            Inner join (default):
                          </p>
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 mb-3 whitespace-pre-wrap">
                            {`FROM table1 JOIN table2
ON table1.column = table2.column`}
                          </pre>
                          <p className="mb-2 text-sm text-gray-600">
                            Left join keeps all rows from table1:
                          </p>
                          <pre className="font-mono text-sm bg-white p-2 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`FROM table1 LEFT JOIN table2
ON table1.column = table2.column`}
                          </pre>
                        </div>
                      </div>

                      {/* Window Functions */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2">
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                            />
                          </svg>
                          <h4 className="font-medium">Window Functions</h4>
                        </div>
                        <div className="p-4">
                          <p className="mb-2 text-sm text-gray-600">
                            Rank products by price within category:
                          </p>
                          <pre className="font-mono text-sm bg-white p-3 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`SELECT 
  product_name,
  category,
  price,
  RANK() OVER (
    PARTITION BY category
    ORDER BY price DESC
  ) as price_rank
FROM products;`}
                          </pre>
                        </div>
                      </div>

                      {/* Common Table Expressions (WITH) */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2">
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                            />
                          </svg>
                          <h4 className="font-medium">
                            Common Table Expressions (WITH)
                          </h4>
                        </div>
                        <div className="p-4">
                          <pre className="font-mono text-sm bg-white p-3 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`WITH high_value_customers AS (
  SELECT customer_id, SUM(total) as total_spent
  FROM orders
  GROUP BY customer_id
  HAVING SUM(total) > 1000
)
SELECT c.name, hvc.total_spent
FROM customers c
JOIN high_value_customers hvc 
  ON c.id = hvc.customer_id
ORDER BY hvc.total_spent DESC;`}
                          </pre>
                        </div>
                      </div>

                      {/* String Functions */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2">
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"
                            />
                          </svg>
                          <h4 className="font-medium">String Functions</h4>
                        </div>
                        <div className="p-4">
                          <pre className="font-mono text-sm bg-white p-3 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`LOWER(string) -- convert to lowercase
UPPER(string) -- convert to uppercase
LENGTH(string) -- string length
SUBSTRING(string, start, length)
CONCAT(string1, string2, ...)
REPLACE(string, from, to)`}
                          </pre>
                        </div>
                      </div>

                      {/* Data Type Conversion */}
                      <div className="bg-blue-50 rounded-lg border border-blue-100 overflow-hidden">
                        <div className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2">
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
                            />
                          </svg>
                          <h4 className="font-medium">Data Type Conversion</h4>
                        </div>
                        <div className="p-4">
                          <pre className="font-mono text-sm bg-white p-3 rounded-md border border-gray-200 text-gray-800 whitespace-pre-wrap">
                            {`-- Two equivalent methods:
CAST(expression AS type)
expression::type

-- Examples:
CAST(price AS integer)
order_date::date
amount::numeric(10,2)`}
                          </pre>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 px-6 py-4 flex justify-end border-t border-gray-200">
                    <form method="dialog">
                      <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-md transition-colors">
                        Close Reference
                      </button>
                    </form>
                  </div>
                </div>
              </dialog>

              <div
                className={`max-w-full mx-auto ${
                  isDarkMode ? "bg-gray-800" : "bg-white"
                } rounded-lg`}
              >
                {/* Question Section */}
                <div className="mb-6">
                  <div
                    className={`${
                      isDarkMode
                        ? "bg-blue-900 border-blue-700"
                        : "bg-blue-50 border-blue-500"
                    } border-l-4 rounded-md px-4 py-3 mb-4`}
                  >
                    <p
                      className={`text-lg font-semibold ${
                        isDarkMode ? "text-gray-100" : "text-gray-800"
                      }`}
                    >
                      {question ? question[0].question : ""}
                    </p>
                  </div>
                  <div
                    className={`prose max-w-none ${
                      isDarkMode ? "text-gray-300" : "text-gray-700"
                    } px-2`}
                  >
                    {question ? question[0].html : ""}
                  </div>
                </div>

                {/* Schema Section */}
                <div className="mb-8">
                  <div
                    className={`${
                      isDarkMode
                        ? "bg-gray-700 text-gray-200"
                        : "bg-gray-800 text-white"
                    } rounded-md px-4 py-2.5 mb-4 shadow-sm`}
                  >
                    <h2 className="text-base font-medium text-center">
                      1. Schema
                    </h2>
                  </div>

                  <div className="space-y-5">
                    {/* First Schema */}
                    <div
                      className={`${
                        isDarkMode
                          ? "bg-gray-700 border-gray-600"
                          : "bg-gray-50 border-gray-100"
                      } p-4 rounded-lg border`}
                    >
                      <div className="flex items-center mb-3">
                        <div className="w-2 h-10 bg-blue-500 rounded-r mr-2"></div>
                        <h3
                          className={`text-base font-medium ${
                            isDarkMode ? "text-gray-200" : "text-gray-700"
                          }`}
                        >
                          {question &&
                            question[0].hasOwnProperty("table_schema1") &&
                            question[0].table_schema1}
                        </h3>
                      </div>
                      <div
                        className={`${
                          isDarkMode
                            ? "bg-gray-800 border-gray-600"
                            : "bg-white border-gray-100"
                        } rounded-lg shadow-sm border overflow-x-auto`}
                      >
                        {question ? (
                          <DataTable
                            data={question[0].schema}
                            isDarkMode={isDarkMode}
                          />
                        ) : (
                          <span className="loading loading-infinity loading-lg"></span>
                        )}
                      </div>
                    </div>

                    {/* Second Schema */}
                    {question && question[0].hasOwnProperty("schema2") && (
                      <div
                        className={`${
                          isDarkMode
                            ? "bg-gray-700 border-gray-600"
                            : "bg-gray-50 border-gray-100"
                        } p-4 rounded-lg border`}
                      >
                        <div className="flex items-center mb-3">
                          <div className="w-2 h-10 bg-blue-500 rounded-r mr-2"></div>
                          <h3
                            className={`text-base font-medium ${
                              isDarkMode ? "text-gray-200" : "text-gray-700"
                            }`}
                          >
                            {question[0].table_schema2}
                          </h3>
                        </div>
                        <div
                          className={`${
                            isDarkMode
                              ? "bg-gray-800 border-gray-600"
                              : "bg-white border-gray-100"
                          } rounded-lg shadow-sm border overflow-x-auto`}
                        >
                          <DataTable
                            data={question[0].schema2}
                            isDarkMode={isDarkMode}
                          />
                        </div>
                      </div>
                    )}

                    {/* Third Schema */}
                    {question && question[0].hasOwnProperty("schema3") && (
                      <div
                        className={`${
                          isDarkMode
                            ? "bg-gray-700 border-gray-600"
                            : "bg-gray-50 border-gray-100"
                        } p-4 rounded-lg border`}
                      >
                        <div className="flex items-center mb-3">
                          <div className="w-2 h-10 bg-blue-500 rounded-r mr-2"></div>
                          <h3
                            className={`text-base font-medium ${
                              isDarkMode ? "text-gray-200" : "text-gray-700"
                            }`}
                          >
                            {question[0].table_schema3}
                          </h3>
                        </div>
                        <div
                          className={`${
                            isDarkMode
                              ? "bg-gray-800 border-gray-600"
                              : "bg-white border-gray-100"
                          } rounded-lg shadow-sm border overflow-x-auto`}
                        >
                          <DataTable
                            data={question[0].schema3}
                            isDarkMode={isDarkMode}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Data Table Section */}
                <div className="mb-8">
                  <div
                    className={`${
                      isDarkMode
                        ? "bg-gray-700 text-gray-200"
                        : "bg-gray-800 text-white"
                    } rounded-md px-4 py-2.5 mb-4 shadow-sm`}
                  >
                    <h2 className="text-base font-medium text-center">
                      2. Data Table
                    </h2>
                  </div>
                  <div className="space-y-5">
                    {/* First Table */}
                    <div
                      className={`${
                        isDarkMode
                          ? "bg-gray-700 border-gray-600"
                          : "bg-gray-50 border-gray-100"
                      } p-4 rounded-lg border`}
                    >
                      <div className="flex items-center mb-3">
                        <div className="w-2 h-10 bg-green-500 rounded-r mr-2"></div>
                        <h3
                          className={`text-base font-medium ${
                            isDarkMode ? "text-gray-200" : "text-gray-700"
                          }`}
                        >
                          {question &&
                            question[0].hasOwnProperty("table_name1") &&
                            question[0].table_name1}
                        </h3>
                      </div>
                      <div
                        className={`${
                          isDarkMode
                            ? "bg-gray-800 border-gray-600"
                            : "bg-white border-gray-100"
                        } rounded-lg shadow-sm overflow-x-auto border`}
                      >
                        {question ? (
                          <DataTable
                            data={question[0].table}
                            isDarkMode={isDarkMode}
                          />
                        ) : (
                          <span className="loading loading-infinity loading-lg"></span>
                        )}
                      </div>
                    </div>

                    {/* Second Table */}
                    {question && question[0].hasOwnProperty("table2") && (
                      <div
                        className={`${
                          isDarkMode
                            ? "bg-gray-700 border-gray-600"
                            : "bg-gray-50 border-gray-100"
                        } p-4 rounded-lg border`}
                      >
                        <div className="flex items-center mb-3">
                          <div className="w-2 h-10 bg-green-500 rounded-r mr-2"></div>
                          <h3
                            className={`text-base font-medium ${
                              isDarkMode ? "text-gray-200" : "text-gray-700"
                            }`}
                          >
                            {question[0].table_name2}
                          </h3>
                        </div>
                        <div
                          className={`${
                            isDarkMode
                              ? "bg-gray-800 border-gray-600"
                              : "bg-white border-gray-100"
                          } rounded-lg shadow-sm overflow-x-auto border`}
                        >
                          <DataTable
                            data={question[0].table2}
                            isDarkMode={isDarkMode}
                          />
                        </div>
                      </div>
                    )}

                    {/* Third Table */}
                    {question && question[0].hasOwnProperty("table3") && (
                      <div
                        className={`${
                          isDarkMode
                            ? "bg-gray-700 border-gray-600"
                            : "bg-gray-50 border-gray-100"
                        } p-4 rounded-lg border`}
                      >
                        <div className="flex items-center mb-3">
                          <div className="w-2 h-10 bg-green-500 rounded-r mr-2"></div>
                          <h3
                            className={`text-base font-medium ${
                              isDarkMode ? "text-gray-200" : "text-gray-700"
                            }`}
                          >
                            {question[0].table_name3}
                          </h3>
                        </div>
                        <div
                          className={`${
                            isDarkMode
                              ? "bg-gray-800 border-gray-600"
                              : "bg-white border-gray-100"
                          } rounded-lg shadow-sm overflow-x-auto border`}
                        >
                          <DataTable
                            data={question[0].table3}
                            isDarkMode={isDarkMode}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Example Output Section */}
                <div>
                  <div
                    className={`${
                      isDarkMode
                        ? "bg-gray-700 text-gray-200"
                        : "bg-gray-800 text-white"
                    } rounded-md px-4 py-2.5 mb-4 shadow-sm`}
                  >
                    <h2 className="text-base font-medium text-center">
                      3. Example Output
                    </h2>
                  </div>
                  <div
                    className={`${
                      isDarkMode
                        ? "bg-gray-700 border-gray-600"
                        : "bg-gray-50 border-gray-100"
                    } p-4 rounded-lg border`}
                  >
                    <div className="flex items-center mb-3">
                      <div className="w-2 h-10 bg-purple-500 rounded-r mr-2"></div>
                      <h3
                        className={`text-base font-medium ${
                          isDarkMode ? "text-gray-200" : "text-gray-700"
                        }`}
                      >
                        Expected Result
                      </h3>
                    </div>
                    <div
                      className={`${
                        isDarkMode
                          ? "bg-gray-800 border-gray-600"
                          : "bg-white border-gray-100"
                      } rounded-lg shadow-sm overflow-x-auto border`}
                    >
                      {question ? (
                        <DataTable
                          data={question[0].example_output}
                          isDarkMode={isDarkMode}
                        />
                      ) : (
                        <span className="loading loading-infinity loading-lg"></span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={`${
              isDarkMode
                ? "border-gray-700 bg-gray-800"
                : "border-gray-200 bg-white"
            } border rounded-md shadow-sm p-1 h-full`}
          >
            <Split
              sizes={[50, 50]}
              minSize={200}
              expandToMin={false}
              gutterSize={6}
              gutterAlign="center"
              snapOffset={30}
              dragInterval={1}
              direction="vertical"
              cursor="row-resize"
              className="overflow-hidden h-full"
            >
              {/* First split section - SQL Editor */}
              <div
                className={`${
                  isDarkMode
                    ? "border-gray-600 bg-gray-800"
                    : "border-gray-300 bg-white"
                } border rounded-md shadow-sm flex flex-col h-full`}
              >
                <div
                  className={`${
                    isDarkMode
                      ? "bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600"
                      : "bg-gradient-to-r from-gray-50 to-gray-100 border-gray-200"
                  } border-b px-4 py-2 flex items-center justify-between rounded-t-lg`}
                >
                  <div className="flex items-center space-x-3">
                    <h2
                      className={`text-base font-semibold ${
                        isDarkMode ? "text-gray-200" : "text-gray-800"
                      } flex items-center gap-1.5`}
                    >
                      <BiLogoPostgresql className="text-xl text-blue-500" />
                      SQL Playground
                    </h2>

                    {/* Timer Display */}
                    <div className="flex items-center gap-2 sm:gap-3">
                      <div
                        className={`px-2.5 py-1 ${
                          isDarkMode
                            ? "bg-gray-700 border-gray-600"
                            : "bg-gray-50 border-gray-200"
                        } border rounded-md flex items-center gap-1.5 shadow-sm`}
                      >
                        <svg
                          className={`w-3.5 h-3.5 sm:w-4 sm:h-4 ${
                            isDarkMode ? "text-gray-400" : "text-gray-500"
                          }`}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <span
                          className={`text-xs sm:text-sm font-mono font-medium ${
                            isDarkMode ? "text-gray-300" : "text-gray-700"
                          }`}
                        >
                          {formatTime(time)}
                        </span>
                      </div>

                      {/* Timer Controls */}
                      <div className="flex items-center gap-1.5">
                        {!timerRunning ? (
                          <button
                            onClick={startTimer}
                            className={`p-1.5 rounded-md ${
                              isDarkMode
                                ? "bg-emerald-900 text-emerald-300 border-emerald-700 hover:bg-emerald-800"
                                : "bg-emerald-50 text-emerald-600 border-emerald-200 hover:bg-emerald-100"
                            } border transition-colors`}
                            title="Start Timer"
                          >
                            <svg
                              className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M8 5v14l11-7z" />
                            </svg>
                          </button>
                        ) : (
                          <button
                            onClick={pauseTimer}
                            className={`p-1.5 rounded-md ${
                              isDarkMode
                                ? "bg-amber-900 text-amber-300 border-amber-700 hover:bg-amber-800"
                                : "bg-amber-50 text-amber-600 border-amber-200 hover:bg-amber-100"
                            } border transition-colors`}
                            title="Pause Timer"
                          >
                            <svg
                              className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                            </svg>
                          </button>
                        )}
                        <button
                          onClick={resetTimer}
                          className={`p-1.5 rounded-md ${
                            isDarkMode
                              ? "bg-gray-700 text-gray-300 border-gray-600 hover:bg-gray-600"
                              : "bg-gray-50 text-gray-600 border-gray-200 hover:bg-gray-100"
                          } border transition-colors`}
                          title="Reset Timer"
                        >
                          <svg
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Move the three editor buttons here */}
                  <div className="flex items-center space-x-2">
                    <button
                      onClick={() => {
                        setShowKeyboardShortcuts(false);
                        setShowQueryHistory(false);
                        setIsEditorExpanded(!isEditorExpanded);
                      }}
                      className={`inline-flex items-center gap-1 px-2 py-1 ${
                        isDarkMode
                          ? "bg-gray-700 hover:bg-gray-600 text-gray-300 border-gray-600"
                          : "bg-slate-100 hover:bg-slate-200 text-slate-700 border-slate-200"
                      } rounded-md transition-colors text-xs font-medium border`}
                    >
                      <svg
                        className="w-3 h-3"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        {isEditorExpanded ? (
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 9L4 4m0 0l5-5M4 4L9 9M15 9l5-5m0 0l-5-5m5 5l-5 5"
                          />
                        ) : (
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M4 8V4m0 0h4M4 4l5 5m11-9h-4m4 0v4m0-4l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                          />
                        )}
                      </svg>
                      <span>{isEditorExpanded ? "Collapse" : "Expand"}</span>
                    </button>
                    <button
                      onClick={() => formatSqlQuery()}
                      className={`inline-flex items-center gap-1 px-2 py-1 ${
                        isDarkMode
                          ? "bg-gray-700 hover:bg-gray-600 text-gray-300 border-gray-600"
                          : "bg-slate-100 hover:bg-slate-200 text-slate-700 border-slate-200"
                      } rounded-md transition-colors text-xs font-medium border`}
                      title="Format SQL (Alt+F / ⌥+F)"
                    >
                      <svg
                        className="w-3 h-3"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 6h16M4 12h16m-7 6h7"
                        />
                      </svg>
                      <span>Format SQL</span>
                    </button>
                    <button
                      onClick={() => setSqlQuery("")}
                      className={`inline-flex items-center gap-1 px-2 py-1 ${
                        isDarkMode
                          ? "bg-gray-700 hover:bg-gray-600 text-gray-300 border-gray-600"
                          : "bg-slate-100 hover:bg-slate-200 text-slate-700 border-slate-200"
                      } rounded-md transition-colors text-xs font-medium border`}
                    >
                      <svg
                        className="w-3 h-3"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        />
                      </svg>
                      <span>Clear</span>
                    </button>
                  </div>

                  {/* Add space between buttons */}
                  <div className="w-1"></div>

                  {/* Query History Button */}
                  <div className="relative">
                    <button
                      ref={queryHistoryButtonRef}
                      onClick={() => toggleQueryHistory()}
                      className={`inline-flex items-center justify-center w-8 h-8 ${
                        showQueryHistory
                          ? isDarkMode
                            ? "bg-blue-900 text-blue-300 border-blue-700"
                            : "bg-blue-100 text-blue-700 border-blue-200"
                          : isDarkMode
                          ? "bg-gray-700 hover:bg-gray-600 text-gray-300 border-gray-600"
                          : "bg-slate-100 hover:bg-slate-200 text-slate-700 border-slate-200"
                      } rounded-md transition-colors text-xs font-medium border`}
                      title="Query History (Alt+H / ⌥+H)"
                    >
                      <RiHistoryLine className="w-4 h-4" />
                    </button>

                    {/* Query History Panel */}
                    {showQueryHistory && (
                      <div
                        ref={queryHistoryRef}
                        className={`absolute right-0 top-9 z-50 w-80 ${
                          isDarkMode
                            ? "bg-gray-800 border-gray-600"
                            : "bg-white border-gray-200"
                        } rounded-lg shadow-lg border max-h-96 overflow-hidden`}
                      >
                        <div
                          className={`${
                            isDarkMode
                              ? "bg-blue-900 border-blue-700"
                              : "bg-blue-50 border-blue-100"
                          } border-b px-4 py-2 flex justify-between items-center`}
                        >
                          <div className="flex items-center gap-2">
                            <RiHistoryLine
                              className={`${
                                isDarkMode ? "text-blue-400" : "text-blue-500"
                              }`}
                            />
                            <h3
                              className={`text-sm font-medium ${
                                isDarkMode ? "text-gray-200" : "text-gray-700"
                              }`}
                            >
                              Query History
                            </h3>
                          </div>
                          <button
                            onClick={() => setShowQueryHistory(false)}
                            className={`${
                              isDarkMode
                                ? "text-gray-400 hover:text-gray-200"
                                : "text-gray-400 hover:text-gray-600"
                            }`}
                          >
                            <svg
                              className="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </button>
                        </div>
                        <div className="overflow-y-auto max-h-80">
                          {queryHistory.length === 0 ? (
                            <div
                              className={`p-4 text-center ${
                                isDarkMode ? "text-gray-400" : "text-gray-500"
                              } text-sm`}
                            >
                              No query history yet
                            </div>
                          ) : (
                            <ul
                              className={`divide-y ${
                                isDarkMode
                                  ? "divide-gray-700"
                                  : "divide-gray-100"
                              }`}
                            >
                              {queryHistory.map((item, index) => (
                                <li
                                  key={index}
                                  className={`p-3 ${
                                    isDarkMode
                                      ? "hover:bg-gray-700"
                                      : "hover:bg-gray-50"
                                  } cursor-pointer ${
                                    item.successful
                                      ? "border-l-2 border-green-500"
                                      : "border-l-2 border-red-500"
                                  }`}
                                  onClick={() => loadQueryFromHistory(item)}
                                >
                                  <div className="flex justify-between items-start mb-1">
                                    <div
                                      className={`text-xs ${
                                        isDarkMode
                                          ? "text-gray-400"
                                          : "text-gray-500"
                                      }`}
                                    >
                                      {new Date(
                                        item.timestamp
                                      ).toLocaleTimeString()}
                                    </div>
                                    <div
                                      className={`text-xs px-1.5 py-0.5 rounded ${
                                        item.successful
                                          ? isDarkMode
                                            ? "bg-green-900 text-green-300"
                                            : "bg-green-100 text-green-800"
                                          : isDarkMode
                                          ? "bg-red-900 text-red-300"
                                          : "bg-red-100 text-red-800"
                                      }`}
                                    >
                                      {item.successful ? "Success" : "Failed"}
                                    </div>
                                  </div>
                                  <div
                                    className={`text-xs font-mono ${
                                      isDarkMode
                                        ? "bg-gray-700 text-gray-300"
                                        : "bg-gray-50"
                                    } p-2 rounded whitespace-pre-wrap max-h-20 overflow-hidden`}
                                  >
                                    {item.query.length > 150
                                      ? item.query.substring(0, 150) + "..."
                                      : item.query}
                                  </div>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Keyboard Shortcuts Button */}
                  <div
                    onMouseEnter={() => setIsHoveringShortcuts(true)}
                    onMouseLeave={() => setIsHoveringShortcuts(false)}
                    className="relative"
                  >
                    <button
                      className={`inline-flex items-center justify-center w-8 h-8 ${
                        isHoveringShortcuts
                          ? isDarkMode
                            ? "bg-blue-900 text-blue-300 border-blue-700"
                            : "bg-blue-100 text-blue-700 border-blue-200"
                          : isDarkMode
                          ? "bg-gray-700 hover:bg-gray-600 text-gray-300 border-gray-600"
                          : "bg-slate-100 hover:bg-slate-200 text-slate-700 border-slate-200"
                      } rounded-md transition-colors text-xs font-medium border`}
                      title="Keyboard Shortcuts"
                    >
                      <FaKeyboard className="w-4 h-4" />
                    </button>

                    {/* Keyboard Shortcuts Panel */}
                    {isHoveringShortcuts && (
                      <div
                        ref={keyboardShortcutsRef}
                        className={`absolute right-0 top-9 z-50 w-96 ${
                          isDarkMode
                            ? "bg-gray-800 border-gray-600"
                            : "bg-white border-gray-200"
                        } rounded-lg shadow-lg border overflow-hidden`}
                      >
                        <div
                          className={`${
                            isDarkMode
                              ? "bg-gray-700 border-gray-600"
                              : "bg-gray-50 border-gray-200"
                          } border-b px-4 py-2 flex justify-between items-center`}
                        >
                          <div className="flex items-center gap-2">
                            <FaKeyboard
                              className={`${
                                isDarkMode ? "text-gray-400" : "text-gray-600"
                              }`}
                            />
                            <h3
                              className={`text-sm font-medium ${
                                isDarkMode ? "text-gray-200" : "text-gray-700"
                              }`}
                            >
                              Keyboard Shortcuts
                            </h3>
                          </div>
                        </div>
                        <div className="p-2">
                          <div
                            className={`mb-2 px-3 py-1 ${
                              isDarkMode
                                ? "bg-blue-900 text-blue-300"
                                : "bg-blue-50 text-blue-700"
                            } rounded text-xs`}
                          >
                            <p>
                              Note: Mac users should use{" "}
                              <span className="font-semibold">⌘ Command</span>{" "}
                              for Execute/Submit and{" "}
                              <span className="font-semibold">⌥ Option</span>{" "}
                              for other shortcuts.
                            </p>
                          </div>
                          <ul
                            className={`divide-y ${
                              isDarkMode ? "divide-gray-700" : "divide-gray-100"
                            }`}
                          >
                            {keyboardShortcuts.map((shortcut, index) => (
                              <li
                                key={index}
                                className="py-2 px-3 flex items-center"
                              >
                                <span
                                  className={`text-sm ${
                                    isDarkMode
                                      ? "text-gray-300"
                                      : "text-gray-700"
                                  } flex-1`}
                                >
                                  {shortcut.description}
                                </span>
                                <div className="flex items-center space-x-2 flex-shrink-0">
                                  <div className="flex items-center">
                                    <span
                                      className={`${
                                        isDarkMode
                                          ? "bg-gray-700 text-gray-300"
                                          : "bg-gray-100 text-gray-800"
                                      } text-xs px-2 py-1 rounded font-mono whitespace-nowrap`}
                                    >
                                      {shortcut.key}
                                    </span>
                                  </div>
                                  <span
                                    className={`text-xs ${
                                      isDarkMode
                                        ? "text-gray-500"
                                        : "text-gray-400"
                                    }`}
                                  >
                                    /
                                  </span>
                                  <div className="flex items-center">
                                    <span
                                      className={`${
                                        isDarkMode
                                          ? "bg-gray-700 text-gray-300"
                                          : "bg-gray-100 text-gray-800"
                                      } text-xs px-2 py-1 rounded font-mono whitespace-nowrap`}
                                    >
                                      {shortcut.macKey}
                                    </span>
                                  </div>
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Code Editor */}
                <div
                  className={`flex-grow relative min-h-0 ${
                    isDarkMode
                      ? "bg-gradient-to-b from-gray-800 to-gray-900"
                      : "bg-gradient-to-b from-slate-50 to-white"
                  }`}
                >
                  {/* Remove the editor header with the buttons as we moved them above */}

                  {/* Popout Editor Modal */}
                  {isEditorExpanded && (
                    <div
                      className="fixed inset-0 z-50 overflow-hidden"
                      onClick={(e) => {
                        if (e.target === e.currentTarget) {
                          setIsEditorExpanded(false);
                        }
                      }}
                    >
                      <div
                        ref={dragRef}
                        className="absolute bg-white rounded-lg shadow-2xl border border-gray-200"
                        style={{
                          left: `${popoutPosition.x}px`,
                          top: `${popoutPosition.y}px`,
                          width: `${expandedSize.width}px`,
                          height: `${expandedSize.height}px`,
                        }}
                      >
                        {/* Draggable Header */}
                        <div
                          className="h-12 bg-gray-100 rounded-t-lg border-b border-gray-200 flex items-center justify-between px-4 cursor-move"
                          onMouseDown={handleDragStart}
                        >
                          <div className="flex items-center space-x-2">
                            <BiLogoPostgresql className="text-xl text-blue-500" />
                            <span className="text-sm font-medium text-gray-700">
                              SQL Editor
                            </span>

                            {/* Timer Display in Expanded View */}
                            <div className="h-4 w-[1px] bg-gray-200 mx-1.5"></div>
                            <div className="flex items-center gap-2">
                              <div className="px-2.5 py-1 bg-white border border-gray-200 rounded-md flex items-center gap-1.5 shadow-sm">
                                <svg
                                  className="w-4 h-4 text-gray-500"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                  />
                                </svg>
                                <span className="text-sm font-mono font-medium text-gray-700">
                                  {formatTime(time)}
                                </span>
                              </div>

                              {/* Timer Controls */}
                              <div className="flex items-center gap-1.5">
                                {!timerRunning ? (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      startTimer();
                                    }}
                                    className="p-1.5 rounded-md bg-emerald-50 text-emerald-600 border border-emerald-200 hover:bg-emerald-100 transition-colors"
                                    title="Start Timer"
                                  >
                                    <svg
                                      className="w-4 h-4"
                                      fill="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path d="M8 5v14l11-7z" />
                                    </svg>
                                  </button>
                                ) : (
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      pauseTimer();
                                    }}
                                    className="p-1.5 rounded-md bg-amber-50 text-amber-600 border border-amber-200 hover:bg-amber-100 transition-colors"
                                    title="Pause Timer"
                                  >
                                    <svg
                                      className="w-4 h-4"
                                      fill="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                                    </svg>
                                  </button>
                                )}
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    resetTimer();
                                  }}
                                  className="p-1.5 rounded-md bg-gray-50 text-gray-600 border border-gray-200 hover:bg-gray-100 transition-colors"
                                  title="Reset Timer"
                                >
                                  <svg
                                    className="w-4 h-4"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                                    />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center space-x-2">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                const formattedQuery = sqlQuery
                                  .replace(/\s+/g, " ")
                                  .replace(/\s*([,()])\s*/g, "$1 ")
                                  .replace(
                                    /\s+(AND|OR|ON|WHERE|FROM|SELECT|JOIN|LEFT|RIGHT|INNER|GROUP BY|ORDER BY|HAVING|LIMIT)\s+/gi,
                                    "\n$1 "
                                  )
                                  .replace(/SELECT\s+/i, "SELECT\n  ")
                                  .replace(/,\s*/g, ",\n  ")
                                  .trim();
                                setSqlQuery(formattedQuery);
                              }}
                              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-md transition-colors text-xs font-medium border border-slate-200"
                            >
                              <svg
                                className="w-3.5 h-3.5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M4 6h16M4 12h16m-7 6h7"
                                />
                              </svg>
                              <span>Format</span>
                            </button>
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                setSqlQuery("");
                              }}
                              className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-md transition-colors text-xs font-medium border border-slate-200"
                            >
                              <svg
                                className="w-3.5 h-3.5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                />
                              </svg>
                              <span>Clear</span>
                            </button>
                            <button
                              onClick={() => setIsEditorExpanded(false)}
                              className="text-gray-500 hover:text-gray-700"
                            >
                              <svg
                                className="w-5 h-5"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>

                        {/* Editor Content */}
                        <div
                          className="p-4"
                          style={{
                            height: `calc(${expandedSize.height}px - 3rem)`,
                          }}
                        >
                          <CodeMirror
                            className="h-full overflow-auto rounded-md [&_.cm-editor]:h-full [&_.cm-scroller]:h-full border border-gray-200"
                            value={sqlQuery}
                            onChange={handleQueryChange}
                            theme={isDarkMode ? "dark" : "light"}
                            extensions={[
                              sql({ dialect }),
                              EditorView.lineWrapping,
                              autocompletion({
                                activateOnTyping: true,
                                maxRenderedOptions: 8,
                                defaultKeymap: true,
                                icons: false,
                              }),
                              cursorPositionExtension,
                              search({
                                top: true,
                                caseSensitive: true,
                              }),
                              searchShortcut,
                            ]}
                            basicSetup={{
                              lineNumbers: true,
                              highlightActiveLineGutter: true,
                              highlightSpecialChars: true,
                              foldGutter: true,
                              dropCursor: true,
                              allowMultipleSelections: true,
                              indentOnInput: true,
                              bracketMatching: true,
                              closeBrackets: true,
                              autocompletion: true,
                              rectangularSelection: true,
                              crosshairCursor: true,
                              highlightActiveLine: true,
                              highlightSelectionMatches: true,
                              closeBracketsKeymap: true,
                              defaultKeymap: true,
                              searchKeymap: true,
                              historyKeymap: true,
                              foldKeymap: true,
                              completionKeymap: true,
                              lintKeymap: true,
                            }}
                          />
                        </div>

                        {/* Resize Handle */}
                        <div
                          ref={resizeRef}
                          className="absolute bottom-0 right-0 w-4 h-4 cursor-se-resize"
                          onMouseDown={(e) => handleResizeStart(e, "se")}
                        >
                          <svg
                            className="w-4 h-4 text-gray-400"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M22 22H20V20H22V22ZM22 18H18V20H22V18ZM18 22H16V24H18V22ZM14 22H12V24H14V22ZM10 22H8V24H10V22Z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  )}

                  <CodeMirror
                    className={`absolute inset-0 pt-0 pb-6 overflow-auto rounded-b-md [&_.cm-editor]:bg-transparent [&_.cm-editor]:px-4 [&_.cm-editor]:py-2
                                                      [&_.cm-focused]:outline-none
                                                      [&_.cm-line]:font-mono [&_.cm-line]:text-[15px]
                                                      ${
                                                        isDarkMode
                                                          ? "[&_.cm-activeLineGutter]:bg-gray-700/80"
                                                          : "[&_.cm-activeLineGutter]:bg-blue-50/50"
                                                      }
                                                      ${
                                                        isDarkMode
                                                          ? "[&_.cm-activeLine]:bg-gray-700/80"
                                                          : "[&_.cm-activeLine]:bg-blue-50/50"
                                                      }
                                                      [&_.cm-gutters]:border-r-0 [&_.cm-gutters]:bg-transparent
                                                      ${
                                                        isDarkMode
                                                          ? "[&_.cm-gutterElement]:text-gray-500"
                                                          : "[&_.cm-gutterElement]:text-slate-400"
                                                      } [&_.cm-gutterElement]:ml-2
                                                      [&_.cm-cursor]:border-blue-500
                                                      ${
                                                        isDarkMode
                                                          ? "[&_.cm-matchingBracket]:bg-green-800 [&_.cm-matchingBracket]:text-green-300"
                                                          : "[&_.cm-matchingBracket]:bg-green-100 [&_.cm-matchingBracket]:text-green-800"
                                                      }
                                                      ${
                                                        isDarkMode
                                                          ? "[&_.cm-selectionBackground]:bg-blue-800"
                                                          : "[&_.cm-selectionBackground]:bg-blue-100"
                                                      }
                                                      ${
                                                        isDarkMode
                                                          ? "[&_.cm-tooltip]:bg-gray-800 [&_.cm-tooltip]:border-gray-600"
                                                          : "[&_.cm-tooltip]:bg-white [&_.cm-tooltip]:border-slate-200"
                                                      } [&_.cm-tooltip]:shadow-lg [&_.cm-tooltip]:rounded-lg
                                                      [&_.cm-completionIcon]:hidden
                                                      [&_.cm-completionLabel]:px-2 [&_.cm-completionLabel]:py-1
                                                      ${
                                                        isDarkMode
                                                          ? "[&_.cm-completionMatchedText]:text-blue-400"
                                                          : "[&_.cm-completionMatchedText]:text-blue-600"
                                                      } [&_.cm-completionMatchedText]:font-medium
                                                      ${
                                                        isDarkMode
                                                          ? "[&_.cm-keyword]:text-purple-400"
                                                          : "[&_.cm-keyword]:text-purple-600"
                                                      } [&_.cm-keyword]:font-medium
                                                      ${
                                                        isDarkMode
                                                          ? "[&_.cm-operator]:text-gray-400"
                                                          : "[&_.cm-operator]:text-slate-500"
                                                      }
                                                      ${
                                                        isDarkMode
                                                          ? "[&_.cm-number]:text-amber-400"
                                                          : "[&_.cm-number]:text-amber-600"
                                                      }
                                                      ${
                                                        isDarkMode
                                                          ? "[&_.cm-string]:text-green-400"
                                                          : "[&_.cm-string]:text-green-600"
                                                      }
                                                      ${
                                                        isDarkMode
                                                          ? "[&_.cm-comment]:text-gray-500"
                                                          : "[&_.cm-comment]:text-slate-400"
                                                      } [&_.cm-comment]:italic`}
                    indentWithTab={true}
                    extensions={[
                      sql({ dialect }),
                      EditorView.lineWrapping,
                      autocompletion({
                        activateOnTyping: true,
                        maxRenderedOptions: 8,
                        defaultKeymap: true,
                        icons: false,
                      }),
                      cursorPositionExtension,
                      search({
                        top: true,
                        caseSensitive: true,
                      }),
                      searchShortcut,
                    ]}
                    placeholder="Write your SQL query here..."
                    value={sqlQuery}
                    onChange={handleQueryChange}
                    theme={isDarkMode ? "dark" : "light"}
                    basicSetup={{
                      lineNumbers: true,
                      highlightActiveLineGutter: true,
                      highlightSpecialChars: true,
                      foldGutter: true,
                      dropCursor: true,
                      allowMultipleSelections: true,
                      indentOnInput: true,
                      bracketMatching: true,
                      closeBrackets: true,
                      autocompletion: true,
                      rectangularSelection: true,
                      crosshairCursor: true,
                      highlightActiveLine: true,
                      highlightSelectionMatches: true,
                      closeBracketsKeymap: true,
                      defaultKeymap: true,
                      searchKeymap: true,
                      historyKeymap: true,
                      foldKeymap: true,
                      completionKeymap: true,
                      lintKeymap: true,
                    }}
                  />

                  {/* Status Bar */}
                  <div
                    className={`absolute bottom-0 left-0 right-0 h-6 ${
                      isDarkMode
                        ? "bg-gray-700 border-gray-600 text-gray-400"
                        : "bg-slate-50 border-slate-200 text-slate-500"
                    } border-t flex items-center justify-between px-4 text-xs`}
                  >
                    <div className="flex items-center space-x-4">
                      <span>SQL</span>
                      <span>UTF-8</span>
                      <span
                        className={`${
                          isDarkMode ? "text-gray-500" : "text-slate-400"
                        }`}
                      >
                        Press Ctrl+F to search
                      </span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <span>
                        Ln {cursorPosition.line}, Col {cursorPosition.column}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Action Bar */}
                <div
                  className={`${
                    isDarkMode
                      ? "bg-gradient-to-r from-gray-700 to-gray-800 border-gray-600"
                      : "bg-gradient-to-r from-gray-50 to-gray-100 border-gray-200"
                  } border-t px-4 py-2 rounded-b-lg`}
                >
                  <div className="flex items-center justify-between">
                    {/* Status Messages */}
                    <div className="flex-1 mr-4">
                      {isButtonDisabled ? (
                        <div
                          className={`flex items-center space-x-2 ${
                            isDarkMode
                              ? "bg-blue-900 border-blue-700"
                              : "bg-blue-50 border-blue-200"
                          } p-1.5 rounded-lg border`}
                        >
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                          <span
                            className={`text-xs ${
                              isDarkMode ? "text-blue-300" : "text-blue-700"
                            } font-medium`}
                          >
                            Processing query...
                          </span>
                        </div>
                      ) : (
                        <div className="text-xs">
                          {correct === "Correct" && (
                            <div
                              className={`flex items-center space-x-2 p-1.5 ${
                                isDarkMode
                                  ? "bg-gradient-to-r from-green-900 to-emerald-900 text-green-300 border-green-700"
                                  : "bg-gradient-to-r from-green-50 to-emerald-50 text-green-700 border-green-200"
                              } rounded-lg border`}
                            >
                              <svg
                                className="w-4 h-4"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                  clipRule="evenodd"
                                />
                              </svg>
                              <span className="font-medium">
                                Your answer is Correct!
                              </span>
                            </div>
                          )}
                          {correct === "Incorrect" && (
                            <div
                              className={`flex items-center space-x-2 p-1.5 ${
                                isDarkMode
                                  ? "bg-gradient-to-r from-red-900 to-rose-900 text-red-300 border-red-700"
                                  : "bg-gradient-to-r from-red-50 to-rose-50 text-red-700 border-red-200"
                              } rounded-lg border`}
                            >
                              <svg
                                className="w-4 h-4"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                                  clipRule="evenodd"
                                />
                              </svg>
                              <span className="font-medium">
                                Your answer is Wrong
                              </span>
                            </div>
                          )}
                          {queryerror && (
                            <div
                              className={`p-1.5 ${
                                isDarkMode
                                  ? "bg-gradient-to-r from-red-900 to-rose-900 text-red-300 border-red-700"
                                  : "bg-gradient-to-r from-red-50 to-rose-50 text-red-700 border-red-200"
                              } border rounded-lg`}
                            >
                              <p className="text-xs font-medium">
                                {queryerror}
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Action Buttons */}
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={executeQuery}
                        disabled={isButtonDisabled}
                        className={`px-3 py-1.5 ${
                          isDarkMode
                            ? "bg-gradient-to-r from-gray-600 to-gray-700 hover:from-gray-700 hover:to-gray-800"
                            : "bg-gradient-to-r from-gray-700 to-gray-800 hover:from-gray-800 hover:to-gray-900"
                        } text-white text-xs font-medium rounded-lg 
                                                    disabled:from-gray-400 disabled:to-gray-500 
                                                    transition-all duration-300 transform hover:scale-105
                                                    focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2
                                                    flex items-center space-x-1.5 shadow-sm hover:shadow-md`}
                        title="Execute Query (Ctrl+Enter)"
                      >
                        <svg
                          className="w-3.5 h-3.5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <span>Execute</span>
                      </button>

                      <button
                        onClick={submitQuery}
                        disabled={isButtonDisabled}
                        className="px-3 py-1.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs font-medium rounded-lg 
                                                    hover:from-blue-600 hover:to-blue-700 disabled:from-blue-400 disabled:to-blue-500 
                                                    transition-all duration-300 transform hover:scale-105
                                                    focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                                                    flex items-center space-x-1.5 shadow-sm hover:shadow-md"
                        title="Submit Query (Ctrl+Shift+Enter)"
                      >
                        <svg
                          className="w-3.5 h-3.5"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <span>Submit</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Results section */}
              <div className="overflow-auto h-full">
                <div
                  className={`flex justify-start w-full h-full ${
                    isDarkMode
                      ? "bg-gradient-to-b from-gray-700 to-gray-800"
                      : "bg-gradient-to-b from-gray-50 to-white"
                  } rounded-lg shadow-inner p-4`}
                >
                  {results ? (
                    <div className="w-full overflow-auto rounded-lg">
                      <DataTable data={results} isDarkMode={isDarkMode} />
                    </div>
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <div className="text-center space-y-4">
                        <div className="relative">
                          <svg
                            className={`mx-auto h-16 w-16 ${
                              isDarkMode ? "text-gray-500" : "text-gray-300"
                            }`}
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={1.5}
                              d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
                            />
                          </svg>
                          <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
                            <span className="animate-ping absolute h-4 w-4 rounded-full bg-blue-400 opacity-75"></span>
                            <span className="relative rounded-full h-3 w-3 bg-blue-500"></span>
                          </div>
                        </div>
                        <div className="space-y-2">
                          <p
                            className={`text-lg font-medium ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            Ready to Execute
                          </p>
                          <p
                            className={`text-sm ${
                              isDarkMode ? "text-gray-400" : "text-gray-500"
                            }`}
                          >
                            Write and execute a query to see results
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Split>
          </div>
        </Split>
      </div>
    </div>
  );
}

export default Main;
